// corresponding to `formatText` command
import { TableModelFlavour } from '@blocksuite/hive-model';

export const FORMAT_TEXT_SUPPORT_FLAVOURS = [
  'hive:paragraph',
  'hive:list',
  'hive:code',
];
// corresponding to `formatBlock` command
export const FORMAT_BLOCK_SUPPORT_FLAVOURS = [
  'hive:paragraph',
  'hive:list',
  'hive:code',
];
// corresponding to `formatNative` command
export const FORMAT_NATIVE_SUPPORT_FLAVOURS = [
  'hive:database',
  TableModelFlavour,
];
